import { motion } from "framer-motion";
import { MousePointerClick, FileText, Send, CalendarCheck, UserCheck, DollarSign, BarChart3 } from "lucide-react";

const steps = [
  { icon: MousePointerClick, text: "A potential customer clicks your ad / engages with you" },
  { icon: FileText, text: "Lands on a high-converting page" },
  { icon: Send, text: "Submits their details" },
  { icon: CalendarCheck, text: "Receives an instant message" },
  { icon: UserCheck, text: "Books an appointment" },
  { icon: DollarSign, text: "Becomes a paying customer" },
  { icon: BarChart3, text: "We optimize performance using real-time data and signals" },
];

export const ExampleFlowSection = () => {
  return (
    <section className="py-20 px-4 bg-secondary">
      <div className="max-w-4xl mx-auto">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            See It In Action
          </h2>
          <p className="text-muted-foreground text-lg">
            Here's what the journey looks like for your next customer.
          </p>
        </motion.div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 md:left-8 top-0 bottom-0 w-0.5 bg-border" />

          <div className="space-y-6">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                className="flex items-center gap-5 relative"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center flex-shrink-0 z-10">
                  <step.icon className="w-5 h-5 md:w-6 md:h-6 text-primary" />
                </div>
                <div className="p-4 rounded-xl bg-card border border-border flex-1">
                  <p className="text-foreground font-medium">{step.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
